import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef, projectDetailSubRouteRef } from './routes';

export const featureFlagsPlugin = createPlugin({
  id: 'feature-flags',
  routes: {
    root: rootRouteRef,
    projectDetail: projectDetailSubRouteRef,
  },
});

export const FeatureFlags = featureFlagsPlugin.provide(
  createRoutableExtension({
    name: 'FeatureFlagsPage',
    component: () =>
      import('./components/FeatureFlagsApp').then(m => m.FeatureFlagsApp),
    mountPoint: rootRouteRef,
  }),
);
